import React from 'react';
import ErrorBoundary from './ErrorBoundary';
import { useNavigate } from 'react-router-dom';
 
interface GlobalErrorBoundaryProps {
    children: React.ReactNode;
}
 
const GlobalErrorBoundary: React.FC<GlobalErrorBoundaryProps> = ({ children }) => {
    const navigate = useNavigate();

 
    return (
        <ErrorBoundary navigate={navigate}>
            {children}
        </ErrorBoundary>
    );
};
 
export default GlobalErrorBoundary;